"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
class JenkinsNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.JENKINS };
    if (props.type !== types_1.NODE_TYPES.JENKINS)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      url: "",
      username: "",
      apiToken: "",
      job: ""
    };
    if (nodeData)
      deserializeData = {
        url: nodeData.host.url,
        username: nodeData.host.username,
        apiToken: nodeData.host.apiToken,
        job: nodeData.job,
        data: nodeData.data
      };
    return deserializeData;
  }
  serialize(uiData) {
    let data = {
      host: {
        url: uiData.url,
        username: uiData.username,
        apiToken: uiData.apiToken
      },
      job: uiData.job,
      data: uiData.data
    };
    return data;
  }
  validate() {
    return new validations_1.JenkinsNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.JenkinsNode = JenkinsNode;
//# sourceMappingURL=JenkinsNode.js.map
